import { render } from "./IfuLots.vue?vue&type=template&id=8d563540&scoped=true"
import script from "./IfuLots.vue?vue&type=script&lang=js"
export * from "./IfuLots.vue?vue&type=script&lang=js"

import "./IfuLots.vue?vue&type=style&index=0&id=8d563540&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_BO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d563540"]])

export default __exports__